import React, { useState } from 'react';
import { toast } from 'sonner';
import { MessageSquare, Send } from 'lucide-react';
import api from '../../utils/axios';
import { Button } from '../ui/button';
import { fFechaHora } from './episodioUtils';

const ETIQUETA = { ESCALAR: 'Escalamiento', FALSO_POSITIVO: 'Falso positivo', AGREGAR_NOTA: 'Nota' };

// G2 (3): notas del episodio.
export const EpisodioNotas = ({ caseId, episodio, onCambio }) => {
  const [texto, setTexto] = useState('');
  const [guardando, setGuardando] = useState(false);
  const agregar = async () => {
    if (!texto.trim()) return;
    setGuardando(true);
    try {
      await api.post(`/cases/${caseId}/alertas/${episodio.id}/notas`, { alerta_id: episodio.id, comentario: texto.trim(), tipo: 'AGREGAR_NOTA' });
      setTexto('');
      toast.success('Nota agregada al episodio');
      onCambio();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'No se pudo agregar la nota');
    } finally { setGuardando(false); }
  };
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4" data-testid="episodio-notas">
      <h4 className="mb-3 flex items-center gap-2 text-sm font-semibold text-slate-700"><MessageSquare size={14} /> Notas del episodio ({episodio.notas.length})</h4>
      <div className="max-h-48 space-y-2 overflow-y-auto">
        {episodio.notas.length === 0 && <p className="text-xs text-slate-400">Sin notas.</p>}
        {[...episodio.notas].reverse().map((n, i) => (
          <div key={n.id || i} className="rounded-lg bg-slate-50 p-2.5 text-xs" data-testid={`episodio-nota-${i}`}>
            <div className="mb-0.5 flex items-center gap-2 text-slate-500">
              <span className="font-semibold text-slate-700">{n.usuario || 'Usuario'}</span>
              {n.tipo && n.tipo !== 'AGREGAR_NOTA' && <span className="rounded bg-white px-1.5 text-[10px]">{ETIQUETA[n.tipo] || n.tipo}</span>}
              <span className="ml-auto text-[10px]">{fFechaHora(n.fecha)}</span>
            </div>
            <p className="text-slate-700">{n.comentario}</p>
          </div>
        ))}
      </div>
      <div className="mt-3 flex gap-2">
        <input value={texto} onChange={(e) => setTexto(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && agregar()}
          placeholder="Escribir una nota…" data-testid="episodio-nota-input"
          className="h-9 flex-1 rounded-md border border-slate-200 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-sky-200" />
        <Button size="sm" onClick={agregar} disabled={guardando || !texto.trim()} className="h-9 bg-slate-800 hover:bg-slate-900" data-testid="episodio-nota-guardar">
          <Send size={14} />
        </Button>
      </div>
    </section>
  );
};

export default EpisodioNotas;
